module.exports = __webpack_public_path__ + "static/media/text.b5aa1735.svg";